export default function initDataCarousel() {
  document.querySelectorAll('[data-carousel]').forEach((carousel) => {
    const id    = carousel.getAttribute('id');
    if (!id) return;
    const items   = Array.from(carousel.querySelectorAll('[data-carousel-item]'));
    const prevBtn = document.querySelector(`[data-carousel-prev="${id}"]`);
    const nextBtn = document.querySelector(`[data-carousel-next="${id}"]`);
    const dots    = Array.from(document.querySelectorAll(`[data-carousel-target="${id}"]`));

    const setActiveDot = (index) => {
      dots.forEach((dot, i) => {
        dot.classList.toggle('bg-cobalt',   i === index);
        dot.classList.toggle('bg-slate-300', i !== index);
      });
    };

    const scrollToIndex = (index) => {
      if (!items.length) return 0;
      const next = (index + items.length) % items.length;
      items[next].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      setActiveDot(next);
      return next;
    };

    let activeIndex = 0;
    setActiveDot(activeIndex);

    if (prevBtn) prevBtn.addEventListener('click', () => { activeIndex = scrollToIndex(activeIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', () => { activeIndex = scrollToIndex(activeIndex + 1); });
    dots.forEach((dot, i) => dot.addEventListener('click', () => { activeIndex = scrollToIndex(i); }));
  });
}
